import React, { useState } from 'react';
import PropTypes from 'prop-types';
import StripeCustomOnboarding from 'components/payments/stripe/StripeCustomOnboarding';
import './styles/SAPaymentsSetupPage.scss';
import { duckify, singleDuck } from 'utils/duckify';
import { customers, rateCards } from 'ducks';
import CountrySelect from '../shared/CountrySelect';
import getUnicodeFlagIcon from 'country-flag-icons/unicode';
import RateCard from '../setup/RateCard'
import Placeholder from '../Placeholder';

const SAPaymentSetupPage = ({ customer, rateCard, allDucksReady }) => {
  const [paymentCountry, setPaymentCountry] = useState(customer.country);

  return (
    <React.Fragment>
      <div className='sa-payments-help'>
        <h2>Payments Onboarding</h2>
        <p>Welcome to Payments customer onboarding.</p>
        <p>Sign-up overview</p>
        <ul>
          <li>The account must be activated by someone authorized to sign on behalf of the organization</li>
          <li>You will need your school’s bank routing and account number</li>
        </ul>
      </div>

      <div className={'cc-payment-country'}>
        <h2>Payment Country</h2>
        <p>This value is set on the <a href='/setup/basic'>Basic Setup</a> page and cannot be changed here.</p>
        <CountrySelect value={paymentCountry}
          filter={c => c.stripeValue}
          getOptionLabel={c => `${getUnicodeFlagIcon(c.stripeValue)} ${c.label}`}
          getOptionValue={c => c.stripeValue}
          onChange={c => setPaymentCountry(c.value)}
          clearable={false}
          disabled={true}
        />
      </div>

      <div className='cc-setup-area'>
        <h2>Payment Setup</h2>
        <StripeCustomOnboarding />
      </div>
      {customer.rate_card_canonical_name !== null ?
        <div className="sa-payment-fees">
          <h2>Payment Fees</h2>
          <p>
            You have the option to either pass these fees onto parents or absorb them.
            If you choose to pass them onto parents, visit the <a href='/setup/payment_setup'>Payment Setup</a> page to configure convenience fee amounts and/or rates for each payment method.
            If you choose not to pass these fees on to parents, the costs will be covered by your school and deducted from your payout amounts.
          </p>
          <Placeholder.loading ready={allDucksReady}>
            <RateCard rate_card_canonical_name={rateCard.canonical_name} readOnly={true} />
          </Placeholder.loading>
        </div> :
        ''
      }
    </React.Fragment>
  );
};

SAPaymentSetupPage.propTypes = {
  customer: PropTypes.shape({
    ach_payment_gateway: PropTypes.string,
    cc_payment_info: PropTypes.shape({
      stripe_account_id: PropTypes.string
    }),
  })
};

SAPaymentSetupPage.defaultProps = {
  customer: {
    ach_payment_gateway: undefined,
    cc_payment_info: {}
  }
};

const mapDucksToProps = () => ({
  customer: singleDuck(customers, 'current'),
  rateCard: singleDuck(rateCards, 'current')
});

export default duckify(mapDucksToProps)(SAPaymentSetupPage);
